import { LocaleConfig } from 'react-native-calendars';
import colors from './colors';
import { Platform } from 'react-native';


export const setCalendarLocale = (localeConfig: typeof LocaleConfig) => {
    localeConfig.locales['he'] = {
        monthNames: [
            'ינואר',
            'פברואר',
            'מרץ',
            'אפריל',
            'מאי',
            'יוני',
            'יולי',
            'אוגוסט',
            'ספטמבר',
            'אוקטובר',
            'נובמבר',
            'דצמבר',
        ],
        monthNamesShort: [
            'ינו.',
            'פבר.',
            'מרץ',
            'אפר.',
            'מאי',
            'יוני',
            'יולי',
            'אוג.',
            'ספט.',
            'אוק.',
            'נוב.',
            'דצמ.',
        ],
        dayNames: ['ראשון', 'שני', 'שלישי', 'רביעי', 'חמישי', 'שישי', 'שבת'],
        dayNamesShort: ['ראשון', 'שני', 'שלישי', 'רביעי', 'חמישי', 'שישי', 'שבת'],
    };
    localeConfig.defaultLocale = 'he';
}

export const rtlTheme: any = {
    // Flip calendar for rtl
    'stylesheet.calendar.main': {
        week: {
            flexDirection: 'row-reverse',
            justifyContent: 'center',
        },
    },
    'stylesheet.calendar.header': {
        header: {
            flexDirection: 'row-reverse',
            justifyContent: 'space-between',
            paddingLeft: 10,
            paddingRight: 10,
            paddingBottom: 20,
            alignItems: 'center',
            height: 45,
        },
        week: {
            marginTop: 7,
            flexDirection: 'row-reverse',
            justifyContent: 'center',
        },
        dayHeader: {
            flex: 1,
            ...Platform.select({
                ios: { width: '14%' }, // 7 days in a week 100/7 = ~14.28%
            }),
            textAlign: 'center',
            fontSize: 13,
            color: colors.greyText       
        }
    },
}